<template>
  <div class="ready-to-submit-alert">
    <div class="ready-to-submit-alert__text">
      <Typography variant="subtitle-1">Ready to Submit</Typography>
      <Typography variant="body-1" class="black--text">
        <template v-if="hasInvalidClaims">
          Valid claims are ready to go. You can fix the invalid claims below first, or submit now
          and fix them later.
        </template>
        <template v-else> Valid claims are ready to go. </template>
      </Typography>
    </div>
    <Button
      class="ready-to-submit-alert__submit"
      :loading="loading"
      @click="$emit('submit-valid-claims', validClaims)"
      >Submit {{ validClaims.length }} Valid
      {{ validClaims.length === 1 ? "Claim" : "Claims" }}</Button
    >
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";

export default {
  name: "ReadyToSubmitAlert",
  components: {
    Typography,
    Button,
  },
  props: {
    validClaims: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hasInvalidClaims: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.ready-to-submit-alert {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  text-align: left;
  background: var(--_components-Alert-Info-Background, #e5f6fd);
}

.ready-to-submit-alert__text {
  flex: 1;
  min-width: 0;
}

.ready-to-submit-alert__submit {
  flex-shrink: 0;
}
</style>
